import * as Toast from '@radix-ui/react-toast'
import { useToast } from './use-toast'
import { X } from 'lucide-react'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <Toast.Provider swipeDirection="right">
      {toasts.map(({ id, title, description, action, variant, ...props }) => (
        <Toast.Root
          key={id}
          className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 flex items-start gap-3 data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full data-[swipe=end]:slide-out-to-right-full"
          {...props}
        >
          <div className="flex-1 grid gap-1">
            {title && (
              <Toast.Title className="text-sm font-medium text-gray-900">
                {title}
              </Toast.Title>
            )}
            {description && (
              <Toast.Description className="text-sm text-gray-600">
                {description}
              </Toast.Description>
            )}
          </div>
          {action}
          <Toast.Close className="text-gray-400 hover:text-gray-600 transition-colors">
            <X className="w-4 h-4" />
          </Toast.Close>
        </Toast.Root>
      ))}
      <Toast.Viewport className="fixed top-0 right-0 flex flex-col p-6 gap-2 w-96 max-w-[100vw] m-0 list-none z-[100] outline-none" />
    </Toast.Provider>
  )
}
